<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="h-screen flex w-full bg-img">
  <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
    <vx-card>
      <div slot="no-body" class="full-page-bg-color">
        <div class="vx-row">
          <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
          </div>
          <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
            <div class="p-8">
              <div class="vx-card__title mb-8">
                <h4 class="mb-4">비밀번호 복구</h4>
                <p>임시비밀번호가 전송됩니다. 이메일을 확인 후 다시 로그인해주세요.</p>
              </div>

              <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-8" />
              <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
              <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0 " @click="findPasswrod">Recover Password</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      value1: ''
    }
  },
  methods: {
    findPasswrod() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
      setTimeout(() => {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, 5000);
      this.$store.dispatch('auth/findPasswrod', {
          email: this.value1
        }).then(() => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '선택했던 프로젝트를 수정하였습니다.'
          })
          this.$router.push('/pages/login')
        })
        .catch(() => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.$vs.notify({
            title: 'Error',
            text: '이메일을 찾을수 없습니다.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
